import { styled } from '@/styled-system/jsx';
import { List } from '@zillow/constellation-10';

export const StyledListItem = styled(List.Item, {
  base: {
    padding: '0 !important',
  },
});
